export namespace CurrencyModuleTest {

	export class Configurator implements Persistance {
		activateAllCurrencies: boolean;

		constructor(persistance?: Persistance) {
			this.activateAllCurrencies = persistance?.activateAllCurrencies ?? false;
		}
		
	}

	export interface Persistance {
		activateAllCurrencies: boolean;
	}
}